// extracted by mini-css-extract-plugin
export var addToCartButton = "_q0-b";
export var arrowButtonContainer = "_q0-9";
export var arrowButtonIcon = "_q0-a";
export var carouselArrowButton = "_q0-6";
export var carouselElementContainer = "_q0-1";
export var left = "_q0-7";
export var productDisplayCarouselContainer = "_q0-0";
export var productTileContainer = "_q0-2";
export var productTileImage = "_q0-4";
export var productTileImageContainer = "_q0-3";
export var productTileTitle = "_q0-5";
export var right = "_q0-8";
export var sliderOverflow = "_q0-c";